import getChilduppProperties from './api'

/**
 * Promise that will resolved to the properties of the current running childupp
 * @type {Promise<Object>}
 */
const CHILDUPP_RPOPERTIES = getChilduppProperties();
export default CHILDUPP_RPOPERTIES

/**
 * Promise that will resolved to the childupp id of the current running childupp
 * @type {Promise<String|Number>}
 */
export const CHILDUPP_ID = CHILDUPP_RPOPERTIES
    .then((props) => props.CHILDUPP_ID)

/**
 * Promise that will resolved to the childupp id of the current running childupp
 * @type {Promise<String|Number>}
 */
export const FIREBASE_CONF = CHILDUPP_RPOPERTIES
    .then((props) => props.FIREBASE_CONF)



// WEBPACK FOOTER //
// ./src/shared/childupp-properties/index.js